<template>
  <b-row>
    <b-col cols="12" md="4" offset-md="4">
      <b-card v-if="!emailUpdated && !emailUpdateError">
        <b-form @submit.prevent="submitEmailChange">
          <b-form-group label="New email address">
            <b-form-input v-model="newEmailAddress" :state="submitted ? !errors.emailaddress ? null: false: null"/>
            <b-form-invalid-feedback>{{ errors.emailaddress }}</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="Please confirm your new email address">
            <b-form-input v-model="confirmationEmailAddress" :state="submitted ? !errors.confirmationemailaddress ? null: false: null"/>
            <b-form-invalid-feedback>{{ errors.confirmationemailaddress }}</b-form-invalid-feedback>
          </b-form-group>

          <div class="d-flex justify-content-center">
            <b-button type="submit" variant="primary">Submit</b-button>
          </div>
        </b-form>
      </b-card>
      <b-card v-else-if="emailUpdated && !emailUpdateError">
        Your email address has been updated and a verification email has been sent to your address. Please follow the link inside.
      </b-card>
      <b-card v-else>
        This link has expired or is invalid. Please register again.
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BButton, BForm, BFormGroup, BFormInput, BFormInvalidFeedback,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
  },
  data() {
    return {
      newEmailAddress: '',
      confirmationEmailAddress: '',
      verificationpassword: '',
      submitted: false,
      emailUpdated: false,
      errors: {},
      emailUpdateError: false,
    }
  },
  created() {
    if (!this.$route.query.ref) {
      this.$router.replace({ name: 'error-404' })
    } else {
      this.verificationpassword = this.$route.query.ref
    }
  },
  methods: {
    validateForm() {
      this.errors = {}

      if (!this.newEmailAddress) {
        this.errors.emailaddress = 'Please fill in this field'
      }

      if (!this.confirmationEmailAddress) {
        this.errors.confirmationemailaddress = 'Please fill in this field'
      }

      // Overload checks
      if (this.newEmailAddress.trim() && !this.newEmailAddress.trim().includes('@')) {
        this.errors.emailaddress = 'Please enter a valid email address'
      }
      if (this.newEmailAddress.trim() && this.confirmationEmailAddress.trim() && this.newEmailAddress.trim() !== this.confirmationEmailAddress.trim()) {
        this.errors.confirmationemailaddress = 'Confirmation email address does not match'
      }
    },
    submitEmailChange() {
      this.validateForm()
      this.submitted = true
      if (Object.keys(this.errors).length === 0) {
        this.$http.post('userregistration.cfc?method=changeEmailAddress', new URLSearchParams({
          hashcode: this.verificationpassword,
          newEmailAddress: this.newEmailAddress.trim(),
        }))
          .then(response => {
            if (!response.data.status) {
              if ('errors' in response.data) {
                this.errors = response.data.errors
              } else {
                this.emailUpdateError = true
              }
            } else {
              this.emailUpdated = true
            }
          })
      }
    },
  },
}
</script>
